import { ref } from 'vue';

const getProjectTypes = () => {
    const projecttypes_error = ref(null);
    const projecttypes = ref(null);

    const loadProjectTypes = async () => {
      try {
        let data = await fetch("/api/projecttypes");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        projecttypes.value = await data.json();

        // console.log('projecttypes', projecttypes.value);
      } catch (err) {
        projecttypes_error.value = err.message;
      }
    };

    return { projecttypes, projecttypes_error, loadProjectTypes};
}

export default getProjectTypes;